export const gap = 16
export const gutter = [gap, gap]

export const filterCol = {
  region: {
    sm: 6,
    xs: 12
  },
  product: {
    sm: 12,
    xs: 24
  }
}

export const infoCol = {
  left: {
    md: {
      span: 8,
      offset: 8
    },
    sm: 24,
    xs: 24
  },
  right: { 
    md: 8,
    sm: 24,
    xs: 24
  }
}

export const titleCol = {
  sm: {
    span: 10,
    offset: 7
  },
  xs: {
    span: 24,
    offset: 0
  }
}

const first = 1
const second = 2
const third = 3

export const noticeCol = {
  span: 24,
  sm: {
    order: first
  },
  xs: {
    order: second
  }
}

export const mapCol = {
  sm: {
    span: 12,
    order: third
  },
  xs: {
    span: 24,
    order: first
  }
}

export const listCol = {
  sm: {
    span: 12,
    order: second
  },
  xs: {
    span: 24,
    order: third
  }
}
